import axios from 'axios'
import * as t from 'io-ts'

import { Org } from '@espoon-voltti/nuora-domain/applicants'

import {
  OrgDto,
  orgDtoToDomain
} from '@espoon-voltti/nuora-app-common/services/dtos'

import { apiBaseUrl, extractResponseData } from './utils'

export interface OrgApi {
  getAll(): Promise<Org[]>
  getById(id: string): Promise<Org>
  getByIdRaw(id: string): Promise<any>
}

export class OrgApiClient implements OrgApi {
  public getAll() {
    return axios
      .get(`${apiBaseUrl}/organisations/v2/organisations`)
      .then(extractResponseData)
      .then((r) => {
        const validOrgDtos = t.array(OrgDto).decodeOrThrow(r)
        return validOrgDtos.map(orgDtoToDomain)
      })
  }

  public getById(id: string) {
    return axios
      .get(`${apiBaseUrl}/organisations/v2/organisations/${id}`)
      .then(extractResponseData)
      .then((r) => {
        const validApplicationDto = OrgDto.decodeOrThrow(r)
        return orgDtoToDomain(validApplicationDto)
      })
  }

  public getByIdRaw(id: string) {
    return axios
      .get(`${apiBaseUrl}/organisations/v2/organisations/${id}`)
      .then(extractResponseData)
  }
}

export const orgApi: OrgApi = new OrgApiClient()
